import { CRONOFY_MANAGE_EXTERNAL_EVENT } from '@/gql/cronofy';
import { CronofyManageExternalEventPayload, CronofyManageExternalEventResponse } from '@/gql/cronofy/types';
import { fetchData } from '@/services/graphql';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';

type APIError = {
  message: string;
  response?: {
    errors?: Array<{ message: string }>;
  };
};

const useCronofyManageExternalEvent = (
  options?: UseMutationOptions<CronofyManageExternalEventResponse, APIError, CronofyManageExternalEventPayload>,
) => {
  return useMutation({
    mutationFn: (payload: CronofyManageExternalEventPayload) =>
      fetchData<CronofyManageExternalEventResponse>(CRONOFY_MANAGE_EXTERNAL_EVENT, payload),
    ...options,
  });
};

export default useCronofyManageExternalEvent;
